console.log("Hello from hike_list_show.ts on vite");
import "./application";
import '../apps/hike_list_manager/main.ts';
import '../apps/download_modal/main';

// Load comments asynchronously to avoid blocking page interactivity (dropdowns, etc.)
const commentsContainer = document.getElementById('comments');
if (commentsContainer) {
  // The share wizard rides along with the comments: a comment's flyover tile opens the fullscreen
  // player, whose Share button needs window.showFlyoverShare (mounted on #flyover_share).
  const loadComments = () => {
    import('../apps/comments/main');
    import('../apps/flyover_share/main');
  };
  // Use requestIdleCallback if available, otherwise fall back to setTimeout
  if ('requestIdleCallback' in window) {
    (window as any).requestIdleCallback(loadComments);
  } else {
    setTimeout(loadComments, 0);
  }
}
